var createMentionData=function(pluginData){return void 0===pluginData&&(pluginData={}),pluginData};export{createMentionData};
//# sourceMappingURL=createMentionData.js.map
